import { useDispatch } from 'react-redux';

import { useMenuBodySnackBarLang } from './useMenuBodySnackBarLang';
import AppActions from 'redux/actions/app-actions/app.actions';

import type { ITurnOffProduct } from 'features/menu-page/domain';

export function useMenuBodySnackBar() {
  const dispatchRedux = useDispatch();

  const lang = useMenuBodySnackBarLang();

  function turnOnItemSuccess() {
    dispatchRedux(
      AppActions.openSnackBarSuccess(
        lang.turnOnItem.success.msg,
        lang.turnOnItem.success.title,
        5_000,
      ),
    );
  }

  function turnOnOffItemError(isTurnOn: boolean = false) {
    dispatchRedux(
      AppActions.openSnackBarError(
        isTurnOn ? lang.turnOnItem.error.msg : lang.turnOffItem.error.msg,
        isTurnOn ? lang.turnOnItem.error.title : lang.turnOffItem.error.title,
        5_000,
      ),
    );
  }

  function turnOffProductSuccess(params: TurnOffProductCTAParams) {
    const { shutdownTimeOption, customDate } = params;
    dispatchRedux(
      AppActions.openSnackBarSuccess(
        lang.turnOffItem.success.msg[shutdownTimeOption].replace(
          '_customDate_',
          customDate.toLocaleDateString('en-CA'),
        ),
        lang.turnOffItem.success.title.product,
        5_000,
      ),
    );
  }

  function turnOffCustomSuccess(params: TurnOffProductCTAParams) {
    const { shutdownTimeOption, customDate } = params;
    dispatchRedux(
      AppActions.openSnackBarSuccess(
        lang.turnOffItem.success.msg[shutdownTimeOption].replace(
          '_customDate_',
          customDate.toLocaleDateString('en-CA'),
        ),
        lang.turnOffItem.success.title.custom,
        5_000,
      ),
    );
  }

  return {
    turnOnItemSuccess,
    turnOnOffItemError,
    turnOffProductSuccess,
    turnOffCustomSuccess,
  };
}

type TurnOffProductCTAParams = Pick<
  ITurnOffProduct,
  'shutdownTimeOption' | 'customDate'
>;
